import {useCallback, useRef} from 'react'

export const useDebounce = (delay: number) => {
  const timeoutRef = useRef<NodeJS.Timeout>()
  return useCallback(
    (func: () => void) => {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => {
        func()
      }, delay)
    },
    [delay]
  )
}
